import { weekdayLabelsPtBr } from '@marketside/shared-contracts';
import { onlyDigits } from './onboarding-state.js';
import type { FulfillmentMethodDraft, PaymentMethodDraft } from './onboarding-state.js';

export { onlyDigits };

export const paymentMethodLabels: Record<PaymentMethodDraft, string> = {
  pix: 'Pix',
  credit: 'Cartão de crédito',
  debit: 'Cartão de débito',
  cash: 'Dinheiro',
  meal_voucher: 'Vale-refeição',
};

export const fulfillmentMethodLabels: Record<FulfillmentMethodDraft, string> = {
  pickup: 'Retirada na loja',
  own_delivery: 'Entrega própria',
  delivery_app: 'Apps/parceiros de entrega',
};

export const dayLabels: Record<string, string> = Object.fromEntries(
  Object.entries(weekdayLabelsPtBr).map(([value, label]) => [value, capitalize(label)]),
);


export function labelOrDash(labels: Record<string, string>, value: string): string {
  const label = labels[value];

  if (!label) {
    return '—';
  }

  return label;
}

export function textOrDash(value: string): string {
  if (!value.trim()) {
    return '—';
  }

  return value;
}

export function formatDateTime(iso: string): string {
  if (!iso) {
    return '—';
  }

  const parsed = new Date(iso);

  if (Number.isNaN(parsed.getTime())) {
    return '—';
  }

  return parsed.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

function capitalize(value: string): string {
  const first = value[0];

  if (!first) {
    return value;
  }

  return `${first.toUpperCase()}${value.slice(1)}`;
}
